import { DefaultBalanceProps } from './types';
import { StyledDefaultBalance } from './style';
import { formattingNumber } from '../../Helper/utils/utils';

const defaultBalanceQuantityFormat = {
    billionShorthand: false,
    fractionalSeparator: '.',
    milSeparator: '',
    millionShorthand: false,
    thousandShorthand: false
};

const DefaultBalance = ({
    balance,
    playerName,
    balanceQuantityFormat = defaultBalanceQuantityFormat
}: DefaultBalanceProps) => {
    return (
        <StyledDefaultBalance playerName={playerName}>
            {balance.image && (
                <img
                    className="balanceImg balance__img"
                    alt="balance"
                    src={balance.image}
                />
            )}
            {balance.amount && (
                <span className={'balance__text'}>
                    {formattingNumber(balance.amount, balanceQuantityFormat)}
                </span>
            )}
        </StyledDefaultBalance>
    );
};

export default DefaultBalance;
